import DashboardPage from "../pages/dashboard/DashboardPage";
import UserPage from "../pages/userPage/UserPage";
import ReportPage from "../pages/reportPage/ReportPage";
import OrganisationPage from "../pages/organisationPage/OrganisationPage";
import SettingPage from "../pages/settingPage/SettingPage";
import AccountPage from "../pages/accountPage/AccountPage";
import CreateOrganisation from "../components/organisation/CreateOrganisation";
import CreateUser from "../components/user/CreateUser";
import UserReviewPage from "../pages/userReviewPage/UserReviewPage";
import AccountDetailsPage from "../pages/accountDetailsPage/AccountDetailsPage";
import Powerbi from "../components/powerbi/Powerbi";
import CreateEnvironment from "../components/environment/CreateEnvironment";
import CreateReport from "../components/report/CreateReport";
import EnvironmentPage from "../pages/environmentPage/EnvironmentPage";
import PackagePage from "../pages/packagePage/PackagePage";
import CreatePackage from "../components/package/CreatePackage";
import VFUserPage from "../pages/vfUserPage/VFUserPage";
import CreateVfUser from "../components/vfuser/CreateVfUser";
import SetupOrganisation from "../pages/setupOrganisation/SetupOrganisation";
import CreateExpenseTarget from "../components/dataTranslation/CreateExpenseTarget";
import ConfigureTranslationPage from "../pages/configureTranslationPage/ConfigureTranslationPage";
import ChannelTranslation from "../components/dataTranslation/ChannelTranslation";
import AppealCategories from "../components/dataTranslation/AppealCategories";
import CustomFieldCategories from "../components/dataTranslation/CustomFieldCategories";
import Categories from "../components/dataTranslation/Categories";

const routes = [
  {
    path: "/dashboard",
    component: DashboardPage,
  },
  {
    path: "/users",
    component: UserPage,
  },
  {
    path: "/organisations",
    component: OrganisationPage,
  },
  {
    path: "/environments",
    component: EnvironmentPage,
  },
  {
    path: "/packages",
    component: PackagePage,
  },
  {
    path: "/vfusers",
    component: VFUserPage,
  },
  {
    path: "/reports",
    component: ReportPage,
  },
  {
    path: "/settings",
    component: SettingPage,
  },
  {
    path: "/my-account",
    component: AccountDetailsPage,
  },
  {
    path: "/add-organisation",
    component: CreateOrganisation,
  },
  {
    path: "/add-user",
    component: CreateUser,
  },
  {
    path: "/add-environment",
    component: CreateEnvironment,
  },
  {
    path: "/add-package",
    component: CreatePackage,
  },
  {
    path: "/add-vfuser",
    component: CreateVfUser,
  },
  {
    path: "/add-report",
    component: CreateReport,
  },
  {
    path: "/edit-vfuser/:userId",
    component: CreateVfUser,
  },
  {
    path: "/edit-report/:reportId",
    component: CreateReport,
  },
  {
    path: "/edit-package/:packageId",
    component: CreatePackage,
  },
  {
    path: "/edit-organisation/:organizationId",
    component: CreateOrganisation,
  },
  {
    path: "/edit-environment/:environmentId",
    component: CreateEnvironment,
  },
  {
    path: "/edit-user/:userId",
    component: CreateUser,
  },
  {
    path: "/expense-target",
    component: CreateExpenseTarget,
  },
  {
    path: "/configure-translations",
    component: ConfigureTranslationPage,
  },
  {
    path: "/channel-translation",
    component: Categories,
  },
  {
    path: "/program-translation",
    component: Categories,
  },
  {
    path: "/appeal-category-translation",
    component: Categories,
  },
  {
    path: "/annualgiving-translation",
    component: Categories,
  },
  {
    path: "/fundpurpose-translation",
    component: Categories,
  },
  {
    path: "/philanthropic-translation",
    component: Categories,
  },
  {
    path: "/appeal-categories",
    component: AppealCategories,
  },
  {
    path: "/campaign-categories",
    component: AppealCategories,
  },
  {
    path: "/appeal-id",
    component: AppealCategories,
  },
  {
    path: "/campaign-id",
    component: AppealCategories,
  },
  {
    path: "dollar-threshold",
    component: AppealCategories,
  },
  {
    path: "fund-categories",
    component: AppealCategories,
  },
  {
    path: "fund-types",
    component: AppealCategories,
  },
  {
    path: "/custom-fields-categories",
    component: CustomFieldCategories,
  },
  {
    path: "/appeal-custom-categories",
    component: CustomFieldCategories,
  },
  {
    path: "/campaign-custom-categories",
    component: CustomFieldCategories,
  },
  {
    path: "/fund-custom-fields",
    component: CustomFieldCategories,
  },
  {
    path: "/user-review",
    component: UserReviewPage,
  },
  {
    path: "/setup-organisation",
    component: SetupOrganisation,
  },
  {
    path: "/reports/:reportTitle/:groupId/:reportId/:profileId",
    component: Powerbi,
  },
];

export default routes;
